import React from 'react';
import { cn } from '../utils/cn';

const Tooltip = ({ text, children, color = 'text-orange-500', image, className }) => {
  return (
    <div className={cn('relative group inline-block z-40', className)}>
      {children}
      <div
        className={`absolute bottom-full mb-2 hidden group-hover:block
                   shadow-sm bg-white ${color} text-xs rounded px-2 py-1
                   select-none
                   text-center
                   border border-gray-400
                   ${image && 'min-w-[270px]'}
                   whitespace-pre
                   pointer-events-none left-1/2 sm:-translate-x-1/2 -translate-x-full`}>
        {image && <img className={'m-auto rounded overflow-hidden object-contain max-w-70'} src={image} alt={'tooltip'} />}
        {text && text}
      </div>
    </div>
  );
};
export default Tooltip;
